import { loaderStyles, overlayStyles } from './CustomLoadingOverlay.css';
import { CustomLoadingOverlayProps } from '../../types/components';

export function CustomLoadingOverlay({ visible = true, children }: CustomLoadingOverlayProps) {
  return (
    <>
      {visible && (
        <>
          <div className={overlayStyles} />
          <div className={loaderStyles}>{children}</div>
        </>
      )}
    </>
  );
}
